
            const data = {"name":"angle-down","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M399 210c0 3-1 5-3 7L263 350c-2 2-5 3-7 3s-5-1-7-3L116 217c-2-2-3-4-3-7 0-2 1-4 3-6l15-15c1-1 4-2 6-2 3 0 5 1 7 2l112 113 112-113c2-1 4-2 7-2 2 0 5 1 6 2l15 15c2 2 3 4 3 6z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    